import { render, staticRenderFns } from "./Savedjobs.vue?vue&type=template&id=43137f81&scoped=true&"
import script from "./Savedjobs.vue?vue&type=script&lang=ts&"
export * from "./Savedjobs.vue?vue&type=script&lang=ts&"
import style0 from "./Savedjobs.vue?vue&type=style&index=0&id=43137f81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43137f81",
  null
  
)

export default component.exports